import { fillPlot, linePlot, numberInput, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { smaAt } from "../math/movingAverages";
import { standardDeviationAt } from "../math/statistics";

/**
 * Bollinger Bands (research §1.4), as TV Bollinger Bands: SMA of the close
 * ± deviation × the population standard deviation.
 */
export default {
  id: "bollinger-bands",
  name: "Bollinger Bands",
  isOscillator: false,
  inputs: [
    periodInput("period", "Period", 5),
    numberInput("deviation", "Deviation", 1),
  ],
  // Colours as on the PO screenshot (04-indicators-menu-legend-pane.jpg)
  plots: [
    linePlot("top", "Top", PALETTE.LIME),
    linePlot("middle", "Middle", PALETTE.AQUA),
    linePlot("bottom", "Bottom", PALETTE.YELLOW),
    fillPlot("background", "Background", PALETTE.LIME, ["top", "bottom"]),
  ],
  levels: [],

  calculate: (bars, { period, deviation }, series, fromIndex) => {
    const read = priceReader(bars, PRICE_SOURCE.CLOSE);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const middle = smaAt(read, index, period);
      const width = deviation * standardDeviationAt(read, index, period);

      series.middle[index] = middle;
      series.top[index] = middle + width;
      series.bottom[index] = middle - width;
    }
  },
};
